import Konva from 'konva';
import { ExportedBoxMath } from './box-math';

export class ExportedBoxIsoDebug {
	public isDebug: boolean = false;

	public cubeGroups: any[] = [];
	public focusGroups: any[] = [];

	public exportedBoxMath: ExportedBoxMath;

	public constructor() {
		this.exportedBoxMath = new ExportedBoxMath();
	}

	public clearAll(): void {
		for (const g of this.cubeGroups) {
			for (const el of g.elements) {
				el.destroy();
			}
		}

		this.cubeGroups.length = 0;

		for (const g of this.focusGroups) {
			for (const el of g.elements) {
				el.destroy();
			}
		}

		this.focusGroups.length = 0;
	}

	public drawFocusOrder(layer, orderedBoxes): void {
		if (!this.isDebug) {
			this.clearAll();

			return;
		}
		for (let i = 0; i < orderedBoxes.length; i++) {
			const box = orderedBoxes[i];

			let group = undefined;

			for (const g of this.focusGroups) {
				if (g.box === box) {
					group = g;

					break;
				}
			}

			if (group) {
				for (const el of group.elements) {
					el.destroy();
				}

				group.elements.length = 0;
			} else {
				group = {
					box: box,
					elements: []
				};

				this.focusGroups.push(group);
			}

			group.elements.push(new Konva.Text({
						x: box.attrs.x + box.attrs.width / 2,
						y: box.attrs.y + box.attrs.height / 2 + 20,
						text: `f=${orderedBoxes.length - i}`,
						fontSize: 50,
						fontFamily: 'Calibri',
						fill: 'black'
					})
			);
		}

		for (const group of this.focusGroups) {
			for (const e of group.elements) {
				layer.add(e);
			}
		}
	}

	public drawCube(layer, box): void {
		if (!this.isDebug) {
			this.clearAll();

			return;
		}

		let group = undefined;

		for (const g of this.cubeGroups) {
			if (g.box === box) {
				group = g;

				break;
			}
		}

		if (group) {
			for (const el of group.elements) {
				el.destroy();
			}

			group.elements.length = 0;
		} else {
			group = {
				box: box,
				elements: []
			};

			this.cubeGroups.push(group);
		}

		const cube = this.exportedBoxMath.getCubeCornersFromBox(box);
		const index = box.attrs.box_index;

		group.elements.push(new Konva.Circle({
			x: cube.tfl.x,
			y: cube.tfl.y,
			radius: 2,
			fill: 'red'
		}));
		group.elements.push(new Konva.Circle({
			x: cube.tfr.x,
			y: cube.tfr.y,
			radius: 2,
			fill: 'red'
		}));
		group.elements.push(new Konva.Circle({
			x: cube.tbl.x,
			y: cube.tbl.y,
			radius: 2,
			fill: 'red'
		}));
		group.elements.push(new Konva.Circle({
			x: cube.tbr.x,
			y: cube.tbr.y,
			radius: 2,
			fill: 'red'
		}));
		group.elements.push(new Konva.Circle({
			x: cube.bfl.x,
			y: cube.bfl.y,
			radius: 2,
			fill: 'red'
		}));
		group.elements.push(new Konva.Circle({
			x: cube.bfr.x,
			y: cube.bfr.y,
			radius: 2,
			fill: 'red'
		}));
		group.elements.push(new Konva.Circle({
			x: cube.bbr.x,
			y: cube.bbr.y,
			radius: 2,
			fill: 'red'
		}));

		group.elements.push(new Konva.Text({
					x: box.attrs.x + box.attrs.width / 2,
					y: box.attrs.y + box.attrs.height / 2 - 20,
					text: `i=${index}`,
					fontSize: 50,
					fontFamily: 'Calibri',
					fill: 'black'
				})
		);

		if (box.attrs.strokeWidth <= 1) {
			box.stroke('black');
			box.strokeWidth(1);
		}

		for (const e of group.elements) {
			layer.add(e);
		}
	}

	public focus(): void {
		if (!this.isDebug) {
			this.clearAll();

			return;
		}

		for (const group of this.cubeGroups) {
			for (const e of group.elements) {
				e.moveToTop();
			}
		}

		for (const group of this.focusGroups) {
			for (const e of group.elements) {
				e.moveToTop();
			}
		}
	}

	public changeIsDebug(debug: boolean): void {
		this.isDebug = debug;
	}
}
